@if (!consultant()) {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
} @else {
  @if (!displayDemandePjPanel()) {
    <lib-fiche-consultant-header
      [consultant]="consultant()!"
      [consultantResiliation]="consultantResiliation()"
      [enableNavigation]="enableNavigation()"
      [showBackButton]="showBackButton()"
      [isExpendSideNav]="isExpendSideNav()"
      (consultantChange)="this.codeConsultant.set($event)"
      (back)="goToPreviousConsultant()"
      (close)="close.emit()"
      (expendSideNav)="expendSideNav.emit()"></lib-fiche-consultant-header>

    <oui-tab-group
      class="fiche-consultant__tabs"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="selectedTabIndex.set($event)">
      <oui-tab label="Profil">
        <lib-fiche-consultant-profil
          [consultant]="consultant()!"
          [disableResiliation]="disableResiliation()"
          (requestResiliation)="requestResiliation.emit()"></lib-fiche-consultant-profil>
      </oui-tab>
      <oui-tab label="Habilitations">
        <lib-fiche-consultant-habilitations
          [consultant]="consultant()!"
          [isBo]="isBo"
          (refreshRequested)="
            refreshConsultant(ficheConsultantTabIndex.habilitations)
          "></lib-fiche-consultant-habilitations>
      </oui-tab>
      @if (isBo) {
        <oui-tab label="Documents & justificatifs ({{ documents().length }})">
          <div class="search-archive-container">
            <oui-searchbar
              class="searchbar"
              placeholder="Rechercher un document"
              [control]="searchControl"></oui-searchbar>
            @if (!isArchive()) {
              <oui-menu [menuItems]="archiveMenuItems">
                <oui-button type="outlined" color="primary">
                  <oui-icon>folder</oui-icon>
                  <span class="archive-label">Archive</span>
                  <oui-icon style="margin-right: -0.5rem">arrow_drop_down</oui-icon>
                </oui-button>
              </oui-menu>
            } @else {
              <oui-button type="contained" color="primary" (click)="setIsArchive()">
                <oui-icon>folder</oui-icon>
                <span class="archive-label">Archive</span>
              </oui-button>
            }
          </div>
          @if (isArchive()) {
            <lib-fiche-consultant-archive
              [codeConsultant]="consultant()?.code"
              [searchValue]="searchValue()"
              [archiveRole]="archiveRole()"
              (resetSearchControl)="this.searchControl.reset('')"
              (documentOpen)="documentOpen.emit($event)"></lib-fiche-consultant-archive>
          } @else {
            <lib-fiche-consultant-documents
              [documents]="documentsFiltered()"
              [viewerDocument]="viewerDocument()"
              (setDisplayDemandePjPanel)="setDisplayDemandePjPanel()"
              (documentOpen)="documentOpen.emit($event)"
              (onRefreshDocs)="onRefreshDocs.emit()"></lib-fiche-consultant-documents>
          }
        </oui-tab>
        <oui-tab label="Activité">
          <lib-fiche-consultant-activite
            [codeConsultant]="consultant()!.code"></lib-fiche-consultant-activite>
        </oui-tab>
      }
    </oui-tab-group>
  } @else {
    <lib-demande-pj-panel
      [codeConsusltant]="consultant()!.code"
      [consultantName]="consultant()!.prenom"
      [consultantLastname]="consultant()!.nom"
      (close)="close.emit()"
      (setDisplayDemandePjPanel)="setDisplayDemandePjPanel()">
    </lib-demande-pj-panel>
  }
}
